import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { ERROR_DELETE_EXPORT_SERVER } from '@/app/module/exports/definitions'
import { createNotification } from '@/app/module/notifications/store/actions'
import { selectOrgId } from '@/app/module/user/store/selectors'
import { esApi, getErrorMessage } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

export const useDeleteExport = () => {
  const dispatch = useAppDispatch()
  const orgId = useSelector(selectOrgId)
  const [deleteExportMutation, deleteExportRes] = esApi.endpoints.deleteExport.useMutation()

  const deleteFn = useCallback(
    async (exportId: number) => {
      try {
        await deleteExportMutation({
          orgId: orgId.toString(),
          exportId,
        }).unwrap()

        dispatch(
          createNotification({
            'delete-export-success': {
              type: 'success',
              message: 'Export deleted successfully.',
            },
          }),
        )
        return true
      } catch (e) {
        dispatch(
          createNotification({
            'delete-export-error': {
              type: 'error',
              message: getErrorMessage(e, ERROR_DELETE_EXPORT_SERVER),
            },
          }),
        )
        return false
      }
    },
    [orgId, dispatch, deleteExportMutation],
  )

  return [deleteFn, deleteExportRes] as const
}
